// extracted by mini-css-extract-plugin
module.exports = {"lds_spinner":"loader_lds_spinner__2Ne5X","lds-spinner":"loader_lds-spinner__cTzgk"};